export default __webpack_public_path__ + "static/media/1915.644d5d4a.png";